/*@flow*/
import type { Node } from 'react';
import { createElement } from 'react';
import type { ComponentPropsT, TransformerFnT, TransformerT } from '../types';
import getTemplate from '../util/getTemplate';
import { getNullOption, isInnerTypeList } from '../util';
import getTransformer from '../util/getTransformer';
import { useLocals, useField, useSelectItems } from '../hooks';

export default function SelectComponent(props: ComponentPropsT): Node {
  const { path } = props;
  const { fieldOptions, typeInfo } = useField(path);
  const isMultiple = isInnerTypeList(typeInfo);
  const transName = isMultiple ? 'multiSelect' : 'singleSelect';
  const tx0: TransformerFnT = (getTransformer(fieldOptions, transName): any);
  const nullOption = getNullOption(fieldOptions);
  const transformer: TransformerT = ((isMultiple ? tx0 : tx0(nullOption)): any);
  const locals = useLocals(path, { transformer });
  const items = useSelectItems(path);
  const template = getTemplate(fieldOptions, 'select');
  return createElement(template, { ...locals, options: items });
}
